import APIClient from '@/shared/http/clients/api'

const resourceName = 'relatorio/atendimento'
const APICore = process.env.APIBaseURLCore

const GetAll = (filters, config = {}) => APIClient.post(`${APICore}/${resourceName}/all`, filters, config)
const ExportAllCardsReport = (dataFilters) => APIClient.post(
  `${APICore}/${resourceName}/export`,
  dataFilters,
  {
    headers: {
      'Content-Type': 'application/json'
    }
  }
)
const ExportAllMessages = (dataFilters, config = {}) => APIClient.post(`${APICore}/${resourceName}/export_messages`, dataFilters, config)
const MedioGetAll = (filters, config = {}) => APIClient.post(`${APICore}/${resourceName}/medio`, filters, {
  ...config,
  timeout: 60000 // 1 minuto
})
const SendExcel = (filters, to, config = {}) =>
  APIClient.post(
    `${APICore}/${resourceName}/sendExcel`,
    filters,
    {
      ...config,
      params: {
        to: to
      }
    }
  )
const ReportAtendimentoRepository = {
  GetAll,
  ExportAllCardsReport,
  MedioGetAll,
  ExportAllMessages,
  SendExcel
}

export default ReportAtendimentoRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/crm/reportAtendimento.js